
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/webbkamera",
      function () {
        return require("private-next-pages/[region]/webbkamera.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/webbkamera"])
      });
    }
  